import { TableColumnTitle } from "./table-column-title";
import { Icons } from "../../../../../enums";
import { TableColumnType } from "../enums";
import { TableColumn } from "../models";
import { Button } from "../../button";

interface TableColumnsRowProps {
	showArrowColumn: boolean;
	hideColumnHeaders: boolean;
  columns: Array<TableColumn>;
	tableColumnsRowActionIcon?: Icons;
	tableColumnsRowAction?: () => void;
	disabledTableColumnsRowAction: boolean;
	handleColumnSorting?: () => void; //TODO after backend
	handleSortRowData: (dataKey: string, reverse: boolean, type?: TableColumnType) => void;
}

export const TableColumnsRow: React.FC<TableColumnsRowProps> = ({
	columns,
	showArrowColumn,
	handleSortRowData,
	hideColumnHeaders,
	handleColumnSorting,
	tableColumnsRowAction,
	tableColumnsRowActionIcon,
	disabledTableColumnsRowAction
}) => {

	return (
		<div className="table-top">
			<div className="table-row header-row">
				{
					!hideColumnHeaders && (
						<div className="table-row-cells">
							<div className="icon-arrow-wrp"></div>
							{
								columns.map(({title, dataKey, hideRow, type, sortable}) => (
									!hideRow ? <TableColumnTitle
										type={type}
										name={title}
										key={dataKey}
										dataKey={dataKey}
										sortable={sortable}
										onClick={handleSortRowData}
										handleColumnSorting={handleColumnSorting}
									/> : null
								))
							}
							{
								tableColumnsRowAction && (
									<Button
										size="md"
										type="button"
										appearance="light"
										onClick={tableColumnsRowAction}
										icon={tableColumnsRowActionIcon}
										disabled={disabledTableColumnsRowAction}
									/>
								)
							}
						</div>
					)
				}
			</div>
		</div>
	);
};
